<script lang="ts">
	import { createEventDispatcher, onDestroy, onMount } from 'svelte'

	interface Props {
		type?: string;
		children?: import('svelte').Snippet;
	}

	let { type = 'full', children }: Props = $props();
	let modal: HTMLElement | null = $state(null)
	let height: number = $state(0)
	let hDiv: number = $state(0)
	let uClass = $derived(() => {
		if (hDiv > height - 40) {
			return 'top'
		}
		return ''
	})

	const dispatch = createEventDispatcher()
	const close = () => dispatch('close')

	function handleKeydown(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			close()
		}
	}

	// Handle back actions using popstate
	function handlePopState() {
		close()
	}

	// Set up event listener on mount and remove on destroy
	onMount(() => {
		// Add a state entry to allow back actions to be detected
		history.pushState(null, '', window.location.href)

		if (typeof window != 'undefined') {
			window.addEventListener('popstate', handlePopState)
		}
	})

	onDestroy(() => {
		if (typeof window != 'undefined') {
			window.removeEventListener('popstate', handlePopState)
		}
	})
</script>

<svelte:window onkeydown={handleKeydown} bind:innerHeight={height} />

<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<div
	class="modal u-overlay-bg {type} {uClass()}"
	role="dialog"
	aria-modal="true"
	bind:this={modal}
	onkeydown={handleKeydown}
	tabindex={0}
>
	<div class="modal__inner" bind:clientHeight={hDiv}>
		<div class="modal__content">
			{@render children?.()}
		</div>
		<button aria-label="Close" class="icon icon-cross" onclick={() => close()}></button>
	</div>
</div>

<style lang="scss">
	.modal {
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 50;
		overflow-y: scroll;
		transition: all linear 0.25s;
		background: rgba(0, 0, 0, 0.4);

		&.top {
			align-items: flex-start;
		}

		&__inner {
			background: white;
			box-shadow: 0 4px 20px 10px rgba(0, 0, 0, 0.12);
			border-radius: 8px;
			padding: 20px;
			position: relative;
			margin: 20px;
			max-width: calc(100% - 40px);

			@media (min-width: 1025px) {
				padding: 30px;
				max-width: calc(100% - 60px);
			}
		}

		button.icon {
			position: absolute;
			top: 20px;
			right: 20px;
			font-size: 20px;

			@media (min-width: 1025px) {
				top: 18px;
				right: 30px;
				font-size: 28px;
			}
		}
	}
</style>
